(() => {
  'use strict';

  const SELECTOR = '[data-faj-brand-marquee]';
  const GLOBAL_KEY = 'FAJBrandMarquee';

  function initSection(section) {
    if (!section || section.dataset.fbmqInitialized === 'true') return;
    section.dataset.fbmqInitialized = 'true';

    const rows = Array.from(section.querySelectorAll('[data-fbmq-row]'));

    rows.forEach((row) => {
      const sequences = row.querySelectorAll('.fbmq-sequence');
      if (sequences.length < 2) return;

      const firstSequence = sequences[0];
      const secondSequence = sequences[1];

      const syncWidth = () => {
        const width = Math.ceil(firstSequence.getBoundingClientRect().width);
        if (!width) return;

        secondSequence.style.minWidth = `${width}px`;
      };

      syncWidth();

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(syncWidth);
        observer.observe(firstSequence);
        row._fbmqObserver = observer;
      } else {
        window.addEventListener('resize', syncWidth, { passive: true });
        row._fbmqResizeHandler = syncWidth;
      }
    });
  }

  function destroySection(section) {
    if (!section) return;
    const rows = Array.from(section.querySelectorAll('[data-fbmq-row]'));

    rows.forEach((row) => {
      if (row._fbmqObserver) {
        row._fbmqObserver.disconnect();
        delete row._fbmqObserver;
      }

      if (row._fbmqResizeHandler) {
        window.removeEventListener('resize', row._fbmqResizeHandler);
        delete row._fbmqResizeHandler;
      }
    });

    delete section.dataset.fbmqInitialized;
  }

  function initAll(scope = document) {
    if (scope.matches?.(SELECTOR)) initSection(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initSection);
  }

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll();
    return;
  }

  window[GLOBAL_KEY] = {
    init: initSection,
    destroy: destroySection,
    initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);
    destroySection(section);
  });
})();
